<template>
  <div>
    <button 
      :class="[buttonSize, buttonStyle, 'button']"
      @click="pressed">
      <slot></slot>
    </button>
  </div>
</template>


<script>
export default {
  name: 'app-button',
  props: {buttonSize: {default: 'is-small'}, buttonStyle: {default: 'is-primary'}},
  methods: {
    pressed() {
      this.eventHub.$emit('Button pressed')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/button.vue